import { render } from "./ContentActions.vue?vue&type=template&id=39616c2c&scoped=true"
import script from "./ContentActions.vue?vue&type=script&lang=js"
export * from "./ContentActions.vue?vue&type=script&lang=js"

import "./ContentActions.vue?vue&type=style&index=0&id=39616c2c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39616c2c"]])

export default __exports__